// General-purpose JSON API instance.
// All interceptor logic lives in createApiInstance — keep this file as a thin export.
import { createApiInstance } from './Createapiinstance';

export default createApiInstance('application/json');